/**
 * Google Analytics 4 (gtag) with Consent Mode v2.
 *
 * - Measurement ID comes from REACT_APP_GA_ID (no hardcoded value).
 * - EU-safe: analytics/ad storage default to "denied"; granted only after
 *   the visitor accepts via the consent banner. Until then GA4 runs in
 *   cookieless mode (no cookies, aggregated pings only).
 * - One GA4 property serves both sites; `site_section` distinguishes them.
 */
const GA_ID_MAIN = process.env.REACT_APP_GA_ID;
const GA_ID_CONSULTING = process.env.REACT_APP_GA_ID_CONSULTING;
const CONSENT_KEY = "sa-analytics-consent"; // "granted" | "denied"

// Both IDs are baked into the shared bundle; pick by site at runtime.
function gaId() {
  if (typeof window !== "undefined" && window.__SITE__ === "consulting") {
    return GA_ID_CONSULTING || GA_ID_MAIN;
  }
  return GA_ID_MAIN;
}

export const analyticsEnabled = () => Boolean(gaId());

export function getStoredConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

function gtag() {
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

export function initAnalytics() {
  const id = gaId();
  if (!id || typeof window === "undefined" || window.__gaInit) return;
  window.__gaInit = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = gtag;

  const stored = getStoredConsent();
  gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: stored === "granted" ? "granted" : "denied",
    wait_for_update: 500,
  });

  gtag("js", new Date());
  const site = window.__SITE__ === "consulting" ? "consulting" : "portfolio";
  gtag("config", id, { anonymize_ip: true, site_section: site });

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
}

export function setConsent(granted) {
  try {
    localStorage.setItem(CONSENT_KEY, granted ? "granted" : "denied");
  } catch {
    /* ignore */
  }
  if (window.gtag) {
    window.gtag("consent", "update", {
      analytics_storage: granted ? "granted" : "denied",
    });
  }
}

export function trackEvent(name, params) {
  if (window.gtag) window.gtag("event", name, params || {});
}
